import CONFIG from './config';

const API_ENDPOINT = {
  GET_SURAHS: `${CONFIG.BASE_URL_SOURCE}/surahs`,
  GET_SURAH: (numberSurah) => `${CONFIG.BASE_URL_SOURCE}/surahs/${numberSurah}`,
  GET_AYAHS: (numberSurah) => `${CONFIG.BASE_URL_SOURCE}/surahs/${numberSurah}/ayahs`,
  GET_AYAH: (numberSurah, numberAyah) => `${CONFIG.BASE_URL_SOURCE}/surahs/${numberSurah}/ayahs/${numberAyah}`,
  GET_RANDOM_AYAH: `${CONFIG.BASE_URL_SOURCE}/random`,
};

export default API_ENDPOINT;
